import React, { FC, memo } from 'react';
import { makeStyles } from '@mui/styles';
import { TextField, AutocompleteProps } from '@mui/material';
import { Autocomplete } from '@mui/lab';

type Role = {
  id: number;
  name: string;
};

type FormControlProps = {
  error?: boolean;
  errorMessage?: string;
} & AutocompleteProps<Role, boolean, boolean, boolean>;

const inputStyles = (error: FormControlProps['error']) => {
  return {
    padding: '7.5px 10px',
    flex: 1,
    borderRadius: 2,
    border: '1px solid',
    borderColor: error ? '#FF7221' : '#E0E7E8',
    // '&:focus': {
    //   borderColor: Color.darkBlue,
    // },
    '&::placeholder': {
      color: '#CACED2',
      opacity: 1,
    },
    '&::-webkit-outer-spin-button, &::-webkit-inner-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0,
    },
    '&[type=number]': {
      '-moz-appearance': 'textfield',
    },
  };
};

export const AutoComplete: FC<FormControlProps> = memo(
  ({ error, errorMessage, ...props }: FormControlProps) => {
    const useStyles = makeStyles({
      root: {
        display: 'flex',
        alignItems: 'center',
        minWidth: 150,
        width: '100%',
        // height: 'unset',
        boxSizing: 'border-box',
        // borderColor: '#E0E7E8',
        // color: '#EB564F',
        border: '1px solid #E0E7E8',
        borderRadius: 4,
        '& .MuiOutlinedInput-notchedOutline': {
          border: 'none',
        },
        height: 50,
        '& input': {
          // border: '1px solid #E0E7E8',
        },
        // backgroundColor: '#E0E7E8',
        '& label.Mui-focused': {
          color: 'black',
          hidden: true,
        },
        '&.Mui-focused': {
          border: '1px solid #FF7221',
          borderRadius: 4,
          color: '#FF7221',
          '& .MuiOutlinedInput-notchedOutline': {
            border: 'none',
          },
        },
      },
      input: {
        fontSize: 16,
        flex: 1,
        color: '#E0E7E8',
        display: 'flex',
        '& input': inputStyles(error),
        '& textarea': inputStyles(error),
      },
      error: {
        color: '#FF7221',
        fontSize: 12,
        marginTop: 3,
        minHeight: 12,
      },
    });

    const classes = useStyles();

    return (
      <>
        <div>
          <Autocomplete disableClearable className={classes.root} {...props} />
        </div>
        <p className={classes.error}>
          {error && errorMessage ? errorMessage : null}
        </p>
      </>
    );
  },
);
